<template>
  <body class="bg-navy text-white overflow-x-hidden">
    <nav class="fixed w-full z-50 bg-navy/90 backdrop-blur-sm border-b border-gray-800">
      <div class="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <div class="font-bold tracking-tighter flex items-center gap-2" style="width: 20rem">
          <a href="https://consumerinsearch.com/">
            <b-img src="https://consumerinsearch.com/files/attach/images/109/2148391c1acb195c367a7c5a131516fe.png" alt="" class="logo_img_dark" width="auto" style="margin: 0px"/>
          </a>
        </div>
        <div class="max-w-3xl md:flex gap-4 text-lg font-medium text-gray-600 transition">
          <a href="https://consumerinsearch.com/report" target="_blank" class="hover:text-black text-lg font-bold transition" style="color: darkgray;">CIS리포트</a>
          <a href="https://consumerinsearch.com/notice" target="_blank" class="hover:text-black text-lg font-bold transition" style="color: darkgray;">공지사항</a>
        </div>
        <a href="/login" class="px-5 py-2 neon-bg text-white font-bold rounded hover:opacity-90 transition">CIS 서비스로 바로가기</a>
        <!-- <a href="/vote2026t" target="_blank" class="px-5 py-2 text-white font-bold rounded hover:opacity-90 transition" style="background-color: lightslategray; margin-left: -90px;">2026 지방선거 서비스로 바로가기</a> 
        <div class="bubble_t p-1 font-bold" style="background-color: #28c76f; backdrop-filter: blur(3px); border: 1px solid #28c76f; font-family: Verdana, sans-serif; font-size: 8px; margin-left: -90px; margin-bottom: 20px;"><i>βeta!</i></div> -->
      </div>
    </nav>

    <header class="relative pt-32 pb-10 lg:pt-48 lg:pb-32 px-6 text-center">
      <div class="max-w-5xl mx-auto">
        <p class="text-gray-800 text-lg mb-4 tracking-widest uppercase">The New Standard of Search Intelligence</p>
        <h1 class="text-4xl md:text-6xl lg:text-7xl font-black mb-6 leading-tight text-gray-800">
          Minimize <span class="text-gray-400">hesitation</span><br>
          Maximize <span class="neon-text">acceleration</span>
        </h1>
        <p class="text-xl md:text-2xl text-gray-800 mb-10 font-light">
          단순한 정보 너머, <strong class="text-black">실행을 위한 최적의 통찰</strong>을 제공합니다.<br>
          이제 고민은 줄이고 성과는 가속화하세요.
        </p>
        <div class="flex flex-col md:flex-row justify-center gap-4">
          <!-- <a href="https://consumerinsearch.com/#section6" target="_blank" class="px-8 py-4 neon-bg text-white font-bold text-lg rounded hover:opacity-90 transition">무료 체험 신청하기</a> -->
          <a href="#" @click.prevent="openTrialPopup" class="px-8 py-4 neon-bg text-white font-bold text-lg rounded hover:opacity-90 transition">무료 체험 신청하기</a>
          <a href="https://consumerinsearch.com/qna" target="_blank" class="px-8 py-4 neon-bg text-white font-bold text-lg rounded hover:opacity-90 transition">서비스 소개서 다운로드</a>
        </div>
        <!-- <div class="flex flex-col md:flex-row justify-center gap-2 mt-2 align-items-center">
          <div class="bubble p-1 font-bold" style="background-color: #28c76f; backdrop-filter: blur(3px); border: 1px solid #28c76f; font-family: Verdana, sans-serif; font-size: 9px;">βeta</div>
          <a href="/vote2026t" class="px-8 py-4 text-white text-lg font-bold rounded hover:opacity-90 transition" style="background-color: lightslategray;">2026 지방선거 서비스로 바로가기</a>
        </div> -->
      </div>
    </header>

    <section id="insights" class="py-20 bg-gray-200/50">
      <div class="max-w-7xl mx-auto px-6">
        <div class="flex justify-between items-end mb-10">
          <div>
            <h2 class="text-3xl font-bold mb-2 text-black">HOT Issue 🔥</h2>
            <!-- <p class="text-gray-800">실시간 검색량 상승율 TOP 5 및 AI 요약 정보 제공 (클릭 시 AI 요약 정보를 볼 수 있습니다.)</p> -->
             <p class="text-gray-800">실시간 검색량 상승율 TOP 5 및 AI 요약 정보 제공</p>
          </div>
          <div class="text-sm text-gray-700 text-right">
            기간: {{ this.period }}<br>주간 검색량 상승율 최다 (전 주 대비)
          </div>
        </div>

        <div class="grid md:grid-cols-3 gap-6">
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 카테고리</h3>
            <div id="loadingCat" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableCat" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_cat_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_cat_top_nm }}</span> <span class="neon-text font-bold">{{ this.hot_cat_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_cat_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.cat_nm }}</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 브랜드 (카테고리)</h3>
            <div id="loadingBrand" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableBrand" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_brand_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_brand_top_nm }} {{ this.hot_brand_top_cat_nm }}</span> <span class="neon-text font-bold">{{ this.hot_brand_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_brand_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.brand }} ({{ object.cat_nm }})</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
          <div class="glass-panel p-6 rounded-xl">
            <h3 class="text-xl font-bold mb-4 border-b border-gray-700 pb-2 text-black">HOT 속성 (카테고리)</h3>
            <div id="loadingProp" class="text-center text-secondary" style="position: absolute; bottom: 8%; left: 40%; visibility: visible;">
              <b-spinner small class="align-middle mr-2"></b-spinner>
              <strong>loaing...</strong>
            </div>
            <ul id="tableProp" class="space-y-4" style="visibility: hidden;">
              <li v-if="this.hot_prop_top_nm == 'empty'" class="flex justify-between items-center"><span class="text-lg text-gray-400">No Data...</span></li>
              <li v-else class="flex justify-between items-center"><span class="text-lg text-black">{{ this.hot_prop_top_nm }} {{ this.hot_prop_top_cat_nm }}</span> <span class="neon-text font-bold">{{ this.hot_prop_top_rate }}</span></li>
              <li class="flex justify-between items-center" v-for="object in hot_prop_others">
                <span class="text-gray-600">{{ object.rank }}. {{ object.prop }} ({{ object.cat_nm }})</span> <span class="text-gray-500 font-bold" style="font-size: 13px;">+{{ object.rate }}%</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section id="features" class="py-24 px-6">
      <div class="max-w-7xl mx-auto space-y-32">      
        <div class="flex flex-col md:flex-row items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full">Pain Point 01</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">아직도 쿼리를 하나씩<br>입력하고 계신가요?</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              실수로 누락되거나, 담당자마다 다른 쿼리를 사용하면 데이터의 일관성이 떨어집니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              카테고리만 선택하세요. 카테고리에 속한 수 만 개의 키워드를 <span class="neon-text font-bold">단 한 번의 클릭으로 즉시 분석</span>해 드립니다.
            </p>
          </div>
          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_1.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row-reverse items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full">Pain Point 02</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">핵심 내용이 한 눈에!<br>AI 자동 분류 시스템</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              매번 직접 분류하느라 결과 확인까지 너무 오래 걸리셨나요?<br>
              실수로 잘못 분류하거나, 조직 내에서도 담당자 마다 분류기준이 다를 수 있습니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              소비자 분석 전문가의 노하우를 학습한 AI가 <span class="neon-text font-bold">더 정확하고 빠르게 브랜드를 분류</span>하고 시각화합니다.
            </p>
          </div>

          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_2.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>

        <div class="flex flex-col md:flex-row items-center gap-12">
          <div class="md:w-1/2">
            <!-- <div class="inline-block px-3 py-1 mb-4 border neon-border neon-text text-sm rounded-full ">Pain Point 03</div> -->
            <h2 class="text-3xl md:text-4xl font-bold mb-6 text-black">급상승한 이유,<br>화면에서 바로 확인하세요.</h2>
            <p class="text-gray-600 text-lg mb-8 leading-relaxed">
              트래픽, 검색량이 튀었는데 이유를 찾느라 시간을 허비하고 계시진 않나요?<br>
              기회도, 위기도 골든타임이 있습니다.
              <br><br>
              <strong class="text-black">Solution:</strong><br>
              이슈가 발생한 키워드를 클릭하세요. <span class="neon-text font-bold">관련 뉴스와 이슈를 팝업으로 즉시 제공</span>하여 빠르고 효과적으로 대응할 수 있습니다.
            </p>
          </div>

          <div class="md:w-1/2 glass-panel p-1 rounded-xl shadow-2xl">
            <div class="bg-gray-500 rounded-lg aspect-video flex items-center justify-center" style="padding: 5px;">
              <b-img src="@/assets/images/intro/cis_3.jpg" alt="" width="auto" style="margin: 0px"/>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="process" class="py-24 bg-gradient-to-b from-navy to-black">
      <div class="max-w-6xl mx-auto px-6 text-center">
        <h2 class="text-3xl md:text-5xl font-bold mb-6 text-black">AI시대, 모든 마케터를 돕는<br>서치 인텔리전스</h2>
        <p class="text-gray-400 text-xl mb-16">
          B2C 기업, 유통 및 커머스, 광고대행사 등 어느 분야에서도<br>
          마케터의 고민을 정확하고 빠르게 해결합니다.
        </p>

        <div class="grid md:grid-cols-3 gap-8 text-left">
          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">📊</div>
            <h3 class="text-2xl font-bold mb-4 text-black">트렌드 파악</h3>
            <p class="text-gray-600 mb-6">"트렌드를 빠르게 예측하고 대응할 수 있는 정확한 솔루션이 없을까요?"</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '친환경 패키징' 검색량 증가 <br>👉 ESG 캠페인 기획
            </div>
          </div>

          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">🧩</div>
            <h3 class="text-2xl font-bold mb-4 text-black">고객 이해</h3>
            <p class="text-gray-600 mb-6">"소비자가 가진 문제를 객관적으로 측정하는 신뢰할 수 있는 솔루션."</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '제로슈거 음료' 검색량 상승 <br>👉 신제품 라인업 강화
            </div>
          </div>

          <div class="bg-gray-100 p-8 rounded-2xl hover:-translate-y-2 transition duration-300">
            <div class="w-12 h-12 neon-bg rounded-lg mb-6 flex items-center justify-center text-black text-2xl">🎯</div>
            <h3 class="text-2xl font-bold mb-4 text-black">시장 반응 평가</h3>
            <p class="text-gray-600 mb-6">"소비자 반응을 제대로 이해하면서, 결과를 빠르게 볼 수 있습니다."</p>
            <div class="text-sm border-t border-gray-700 pt-4 text-black">
              <span class="neon-text font-bold">Case.</span> '전기차 화재' 검색량 급증 <br>👉 안전성 강조 보도자료 배포
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-footer border-t border-gray-900">
      <div class="max-w-7xl mx-auto px-6 py-4">
        <!-- 사업자 정보 -->
        <div class="biz-info">
          <ul class="biz-info-row">
            <li><strong>업트래닉스</strong></li>
            <li><strong>주소</strong> 경기 성남시 분당구 판교로289번길 20, 3동 1층</li>
            <li><strong>대표</strong> 서동완</li>
            <li><strong>사업자등록번호</strong> 546-88-03253</li>
          </ul>
          <ul class="biz-info-row">
            <li><strong>이메일</strong> helpdesk.consumerinsearch@gmail.com</li>
          </ul>
        </div>

        <!-- 저작권 / 링크 -->
        <div class="footer-bottom">
          <strong class="text-white text-sm">Copyright (C) 2025 업트래닉스. All rights reserved.</strong>
          <div class="flex gap-4">
            <a href="https://consumerinsearch.com/privacy" target="_blank" class="text-sm hover:text-white" style="color: lightgray;">개인정보처리방침</a>
            <a href="https://consumerinsearch.com/#section6" target="_blank" class="text-sm hover:text-white" style="color: lightgray;">문의하기</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 광고 유입 전용 무료 체험 팝업 -->
    <b-modal
      v-model="showTrialPopup"
      centered
      hide-header
      hide-footer
      body-class="p-0"
      dialog-class="trial-modal-dialog"
      content-class="trial-modal"
    >
      <button type="button" class="trial-modal-close" @click="showTrialPopup = false" aria-label="닫기">✕</button>

      <div class="flex flex-col md:flex-row">
        <!-- 이미지 영역 -->
        <div class="trial-modal-img md:w-1/2">
          <img src="@/assets/images/intro/trial_popup.png" alt="CIS 무료 체험" />
        </div>

        <!-- 문구 영역 -->
        <div class="md:w-1/2 p-6 flex flex-col justify-center text-left">

          <!-- 신청 전: 입력 폼 -->
          <template v-if="!trialDone">
            <p class="trial-modal-eyebrow neon-text font-bold text-xs tracking-widest">FREE TRIAL</p>
            <h2 class="trial-modal-title text-2xl font-bold text-black leading-tight">
              검색 데이터 분석,<br>이제 AI에게 맡기세요
            </h2>
            <ul class="trial-modal-features text-gray-600 text-sm space-y-2">
              <li>✔ 카테고리 선택 한 번으로 수만 개 키워드 분석</li>
              <li>✔ AI 브랜드·속성 자동 분류</li>
              <li>✔ 급상승 이슈 원인까지 즉시 확인</li>
            </ul>

            <p class="trial-modal-notice">
              ※ 무료 체험은 전체 카테고리 중 <strong>5개 카테고리</strong>만 제공됩니다.
            </p>

            <form @submit.prevent="submitTrial">
              <input
                v-model.trim="trialEmail"
                type="email"
                placeholder="이메일을 입력하세요"
                class="trial-modal-input"
                :class="{ 'is-invalid': trialEmail && !isValidEmail }"
              />
              <p v-if="trialEmail && !isValidEmail" class="trial-modal-error">
                올바른 이메일 형식이 아닙니다.
              </p>
              <p v-else-if="trialNotice" class="trial-modal-error">
                {{ trialNotice }}
              </p>

              <label class="trial-modal-agree">
                <input type="checkbox" v-model="trialAgree" />
                <span>
                  (필수) 개인정보 수집·이용에 동의합니다.
                  <a href="https://consumerinsearch.com/privacy" target="_blank">보기</a>
                </span>
              </label>

              <button
                type="submit"
                class="trial-modal-btn neon-bg text-white font-bold rounded transition"
                :disabled="!canSubmitTrial"
              >
                {{ trialSubmitting ? "신청 중..." : "무료 체험 신청하기" }}
              </button>
            </form>
          </template>

          <!-- 신청 완료 -->
          <div v-else class="text-center">
            <div class="trial-modal-done-icon">✉️</div>
            <h2 class="text-2xl font-bold mb-4 text-black leading-tight">
              신청이 완료되었습니다!
            </h2>
            <p class="text-gray-600 text-sm mb-2">
              <strong class="neon-text">{{ trialEmail }}</strong> 으로<br>
              계정 정보를 보내드렸습니다.
            </p>
            <p class="text-gray-600 text-sm mb-6">
              이메일을 확인해 주세요.
            </p>
            <p class="text-xs text-gray-400 mb-6">
              메일이 보이지 않으면 스팸함을 확인해 주세요.
            </p>
            <button
              type="button"
              class="trial-modal-btn neon-bg text-white font-bold rounded transition hover:opacity-90"
              @click="showTrialPopup = false"
            >확인</button>
          </div>
        </div>
      </div>
    </b-modal>


  </body>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BSpinner,
  BModal,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { $themeConfig } from "@themeConfig";
import useJwt from "@/auth/jwt/useJwt";

import AuthenticationService from "@/services/authentication.service";
import IntroService from "@/services/cis-intro.service";

import axios from "axios"

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
  name: "Login_Test",
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    BModal,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      trialDone: false,
      trialEmail: "",
      trialAgree: false,
      trialSubmitting: false,
      trialNotice: "",
      showTrialPopup: false,
      period: "",

      hot_cat_top_nm: "",
      hot_cat_top_rate: "",
      hot_cat_others: [],

      hot_brand_top_nm: "",
      hot_brand_top_cat_nm: "",
      hot_brand_top_rate: "",      
      hot_brand_others: [],

      hot_prop_top_nm: "",
      hot_prop_top_cat_nm: "",
      hot_prop_top_rate: "",      
      hot_prop_others: [],
    };
  },
  methods: {
    // getStartDateOfLastWeek() {
    //   const today = new Date();
    //   const currentDayOfWeek = today.getDay(); // 0: 일요일, 1: 월요일, ..., 6: 토요일

    //   console.log(currentDayOfWeek);

    //   // 현재 날짜에서 현재 요일까지의 일수를 빼서 이번 주 월요일로 이동
    //   const sundayOfCurrentWeek = new Date(today);
    //   sundayOfCurrentWeek.setDate(today.getDate() - currentDayOfWeek + 1);

    //   console.log(sundayOfCurrentWeek);

    //   // 이번 주 월요일에서 7일을 더 빼서 지난주 월요일로 이동
    //   const sundayOfLastWeek = new Date(sundayOfCurrentWeek);
    //   sundayOfLastWeek.setDate(sundayOfCurrentWeek.getDate() - 7);

    //   console.log(sundayOfLastWeek);

    //   return sundayOfLastWeek;
    // }
    getStartDate() {
      const today = new Date();

      // 현재 날짜에서 현재 요일까지의 일수를 빼서 이번 주 월요일로 이동
      const sundayOfCurrentWeek = new Date(today);
      sundayOfCurrentWeek.setDate(today.getDate() - 1);

      // 이번 주 월요일에서 7일을 더 빼서 지난주 월요일로 이동
      const sundayOfLastWeek = new Date(sundayOfCurrentWeek);
      sundayOfLastWeek.setDate(sundayOfCurrentWeek.getDate() - 7);

      return sundayOfLastWeek;
    },
    // 무료체험 신청 팝업 열기
    openTrialPopup() {
      // 이전 입력/완료 상태 초기화
      this.trialEmail = "";
      this.trialAgree = false;
      this.trialDone = false;
      this.trialNotice = "";
      this.showTrialPopup = true;
    },
    // 광고 유입 여부 판단
    isFromAd() {
      const q = this.$route.query;
      return q.utm_campaign === "free_trial" || !!q.gclid;
    },
    // 세션 단위 방문 ID
    getVisitId() {
      let id = sessionStorage.getItem("adVisitId");
      if (!id) {
        id = Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
        sessionStorage.setItem("adVisitId", id);
      }
      return id;
    },
    // 광고 유입 기록 (세션당 1회, 실패해도 화면에 영향 없음)
    logAdVisit() {
      if (sessionStorage.getItem("adVisitLogged")) return;
      sessionStorage.setItem("adVisitLogged", "1");

      const q = this.$route.query;
      IntroService.logAdVisit({
        visitId: this.getVisitId(),
        utmSource: q.utm_source || null,
        utmMedium: q.utm_medium || null,
        utmCampaign: q.utm_campaign || null,
        gclid: q.gclid || null,
      }).catch(() => {});
    },
    async submitTrial() {
      if (!this.canSubmitTrial) return;
      this.trialSubmitting = true;
      this.trialNotice = "";
      try {
        const resp = await IntroService.applyFreeTrial({
          email: this.trialEmail,
          visitId: sessionStorage.getItem("fromAd") ? this.getVisitId() : null,
        });

        if (resp.data.data === "ALREADY_APPLIED") {
          this.trialNotice = "이미 무료 체험을 신청하신 이메일입니다. 추가 문의는 관리자(helpdesk.consumerinsearch@gmail.com)에게 부탁드립니다.";
          return;
        }
        this.trialDone = true;
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: { title: "신청 중 오류가 발생했습니다. 다시 시도해 주세요.", icon: "AlertTriangleIcon", variant: "danger" },
        });
      } finally {
        this.trialSubmitting = false;
      }
    },
  },
  watch: {
    showTrialPopup(val) {
      if (!val) sessionStorage.setItem("trialPopupClosed", "1");
    },
    trialEmail() {
      this.trialNotice = "";
    },
  },
  computed: {
    isValidEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(this.trialEmail);
    },
    canSubmitTrial() {
      return this.isValidEmail && this.trialAgree && !this.trialSubmitting;
    },
  },
  mounted() {
    if (this.isFromAd()) {
      sessionStorage.setItem("fromAd", "1");
      this.logAdVisit();
    }

    if (sessionStorage.getItem("fromAd") && !sessionStorage.getItem("trialPopupClosed")) {
      this.showTrialPopup = true;
    }
  },
  setup() {
    console.log('----- setup -----')
    return {}
  },

  async created() {
    console.log('----- created -----')

    // 검색 기간을 설정한다.
    const st_dt = this.getStartDate();
    const en_dt = new Date(st_dt);
    en_dt.setDate(en_dt.getDate() + 6);

    this.period = st_dt.toLocaleDateString('en-CA') + " ~ " + en_dt.toLocaleDateString('en-CA')

    // 전체 카테고리 목록을 가져온다.
    const cat_list = await IntroService.getAllCategory(source);
    const cat_list_data = cat_list.data.data;

    // 전체 카테고리의 지난주 대비 이번주 검색량 변화량을 계산한다.   
    var cat_diff_list = [];
    document.getElementById('loadingCat').style.visibility = "visible";
    document.getElementById('tableCat').style.visibility = "hidden";

    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];

      const diff_rate_resp = await IntroService.getCategorySearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source);
      const resp_data = diff_rate_resp.data.data

      console.log(diff_rate_resp)

      if (resp_data.length <= 0)
        continue;

      cat_diff_list.push({'cat_nm': cat_item.name, 'freq': resp_data[0].diffFreq, 'rate': resp_data[0].diffRate})
    }

    document.getElementById('loadingCat').style.visibility = "hidden";
    document.getElementById('tableCat').style.visibility = "visible";

    if (cat_diff_list.length > 0) {
      // 변화량 기준 정렬
      cat_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(cat_diff_list)

      var tmp_cat_diff_list = cat_diff_list.slice(0, 5);

      if (tmp_cat_diff_list.length > 0) { 
        // 변화율 기준 정렬
        tmp_cat_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_cat_diff_list)

        if (tmp_cat_diff_list[0].rate > 0) {
          this.hot_cat_top_nm = "1. " + tmp_cat_diff_list[0].cat_nm;
          this.hot_cat_top_rate = "+" + tmp_cat_diff_list[0].rate + "%";

          this.hot_cat_others = [];

          for (var idx = 1; idx < tmp_cat_diff_list.length; idx++) {
            if (tmp_cat_diff_list[idx].rate <= 0)
              continue;

            this.hot_cat_others.push({'rank': idx + 1, 'cat_nm': tmp_cat_diff_list[idx].cat_nm, 'rate': tmp_cat_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else
          this.hot_cat_top_nm = "empty"
      }
      else 
        this.hot_cat_top_nm = "empty"
    }
    else 
      this.hot_cat_top_nm = "empty"

    var brand_diff_list = [];
    document.getElementById('loadingBrand').style.visibility = "visible";
    document.getElementById('tableBrand').style.visibility = "hidden";

    // 전체 카테고리의 지난주 대비 이번주 브랜드 검색량 변화량을 계산한다.
    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];
      const cat_brand_diff = await IntroService.getBrandSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source)

      console.log(cat_brand_diff)

      const resp_data = cat_brand_diff.data.data;

      if (resp_data.length > 0) {
        for (var idx = 0; idx < resp_data.length; idx++) {
          if (resp_data[idx].diffRate <= 0)
            break;

          brand_diff_list.push({'cat_nm': cat_item.name, 'brand': resp_data[idx].brand, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate})
        }
      }
    }

    document.getElementById('loadingBrand').style.visibility = "hidden";
    document.getElementById('tableBrand').style.visibility = "visible";

    if (brand_diff_list.length > 0) {
      // 변화량 기준으로 정렬한다.
      brand_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(brand_diff_list)

      var tmp_brand_diff_list = brand_diff_list.slice(0, 5);

      if (tmp_brand_diff_list.length > 0) {
        // 변화율 기준으로 정렬한다.
        tmp_brand_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_brand_diff_list)

        if (tmp_brand_diff_list[0].rate > 0) {
          this.hot_brand_top_nm = "1. " + tmp_brand_diff_list[0].brand;
          this.hot_brand_top_cat_nm = "(" + tmp_brand_diff_list[0].cat_nm + ")";
          this.hot_brand_top_rate = "+" + tmp_brand_diff_list[0].rate + "%";

          this.hot_brand_others = [];

          for (var idx = 1; idx < tmp_brand_diff_list.length; idx++) {
            if (tmp_brand_diff_list[idx].rate <= 0)
              continue;

            this.hot_brand_others.push({'rank': idx + 1, 'cat_nm': tmp_brand_diff_list[idx].cat_nm, 'brand': tmp_brand_diff_list[idx].brand, 'rate': tmp_brand_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else
          this.hot_brand_top_nm = "empty"
      }
      else
        this.hot_brand_top_nm = "empty"
    } 
    else 
      this.hot_brand_top_nm = "empty"

    var prop_diff_list = [];
    document.getElementById('loadingProp').style.visibility = "visible";
    document.getElementById('tableProp').style.visibility = "hidden";

    // 전체 카테고리의 지난주 대비 이번주 브랜드 검색량 변화량을 계산한다.
    for (var cat_idx = 0; cat_idx < cat_list_data.length; cat_idx++) {
      const cat_item = cat_list_data[cat_idx];
      // const cat_prop_diff = await IntroService.getPropSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source) // 속성
      const cat_prop_diff = await IntroService.getPropDetailSearchVolTrends({ schema: cat_item.schema, target_dt: en_dt.toLocaleDateString('en-CA') }, source) // 세부 속성

      console.log(cat_prop_diff)

      const resp_data = cat_prop_diff.data.data;

      if (resp_data.length > 0) {
        for (var idx = 0; idx < resp_data.length; idx++) {
          if (resp_data[idx].diffRate <= 0)
            break;

          // prop_diff_list.push({'cat_nm': cat_item.name, 'prop': resp_data[idx].prop, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate}) // 속성
          prop_diff_list.push({'cat_nm': cat_item.name, 'prop': resp_data[idx].propDt, 'freq': resp_data[idx].diffFreq, 'rate': resp_data[idx].diffRate}) // 세부 속성
        }
      }
    }

    document.getElementById('loadingProp').style.visibility = "hidden";
    document.getElementById('tableProp').style.visibility = "visible";

    if (prop_diff_list.length > 0) {
      // 변화량 기준으로 정렬한다.
      prop_diff_list.sort((a, b) => {
        if (a.freq > b.freq) return -1;
        if (a.freq === b.freq) return 0;
        if (a.freq < b.freq) return 1;
      })

      console.log(prop_diff_list)

      var tmp_prop_diff_list = prop_diff_list.slice(0, 5);

      if (tmp_prop_diff_list.length > 0) {
        // 변화율 기준으로 정렬한다.
        tmp_prop_diff_list.sort((a, b) => {
          if (a.rate > b.rate) return -1;
          if (a.rate === b.rate) return 0;
          if (a.rate < b.rate) return 1;
        })

        console.log(tmp_prop_diff_list)

        if (tmp_prop_diff_list[0].rate > 0) {
          this.hot_prop_top_nm = "1. " + tmp_prop_diff_list[0].prop;
          this.hot_prop_top_cat_nm = "(" + tmp_prop_diff_list[0].cat_nm + ")";
          this.hot_prop_top_rate = "+" + tmp_prop_diff_list[0].rate + "%";

          this.hot_prop_others = [];

          for (var idx = 1; idx < tmp_prop_diff_list.length; idx++) {
            if (tmp_prop_diff_list[idx].rate <= 0)
              continue

            this.hot_prop_others.push({'rank': idx + 1, 'cat_nm': tmp_prop_diff_list[idx].cat_nm, 'prop': tmp_prop_diff_list[idx].prop, 'rate': tmp_prop_diff_list[idx].rate});

            if (idx > 3)
              break;
          }
        }
        else 
          this.hot_prop_top_nm = "empty"
      }
      else 
        this.hot_prop_top_nm = "empty"
    } 
    else 
      this.hot_prop_top_nm = "empty"
  },

  destroyed() {
    console.log('----- destroyed -----')
  }
};
</script>

<style lang="scss">
  /* @import "@core/scss/vue/pages/page-auth.scss"; */

  body { font-family: 'NanumBarunGothic', sans-serif !important; }

  .neon-text { color: #1817E7; }

  .neon-bg { background-color: #1951DC; }

  .neon-border { border-color: #1817E7; }

  .bg-navy { background-color: #FFFFFF; } /* 슬라이드 배경색 유사 */

  .glass-panel {
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.85);
  } 

  *,
  ::before,
  ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: brightness(100%);
    --tw-backdrop-contrast: contrast(100%);
    --tw-backdrop-grayscale: grayscale(100%);
    --tw-backdrop-hue-rotate: hue-rotate(0);
    --tw-backdrop-invert: invert(0%);
    --tw-backdrop-opacity: opacity(100%);
    --tw-backdrop-saturate: saturate(0%);
    --tw-backdrop-sepia: sepia(0%);
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style: ;
  }
  ::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: brightness(100%);
    --tw-backdrop-contrast: contrast(100%);
    --tw-backdrop-grayscale: grayscale(100%);
    --tw-backdrop-hue-rotate: hue-rotate(0);
    --tw-backdrop-invert: invert(0%);
    --tw-backdrop-opacity: opacity(100%);
    --tw-backdrop-saturate: saturate(0%);
    --tw-backdrop-sepia: sepia(0%);
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style: ;
  } /* ! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com */
  *,
  ::after,
  ::before {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: #e5e7eb;
  }
  ::after,
  ::before {
    --tw-content: "";
  }
  :host,
  html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
    tab-size: 4;
    font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-feature-settings: normal;
    font-variation-settings: normal;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    margin: 0;
    line-height: inherit;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    text-decoration: inherit;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  pre,
  samp {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      "Liberation Mono", "Courier New", monospace;
    font-feature-settings: normal;
    font-variation-settings: normal;
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }
  button,
  select {
    text-transform: none;
  }
  button,
  input:where([type="button"]),
  input:where([type="reset"]),
  input:where([type="submit"]) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
  }
  :-moz-focusring {
    outline: auto;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  progress {
    vertical-align: baseline;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
  summary {
    display: list-item;
  }
  blockquote,
  dd,
  dl,
  figure,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  p,
  pre {
    margin: 0 !important;
  }
  fieldset {
    margin: 0;
    padding: 0;
  }
  legend {
    padding: 0;
  }
  menu,
  ol,
  ul {
    list-style: none;
    margin: 0;
    padding: 0 !important;
  }
  dialog {
    padding: 0;
  }
  textarea {
    resize: vertical;
  }
  input::placeholder,
  textarea::placeholder {
    opacity: 1;
    color: #9ca3af;
  }
  [role="button"],
  button {
    cursor: pointer;
  }
  :disabled {
    cursor: default;
  }
  audio,
  canvas,
  embed,
  iframe,
  img,
  object,
  svg,
  video {
    display: block;
    vertical-align: middle;
  }
  img,
  video {
    max-width: 100%;
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .z-50 {
    z-index: 50;
  }
  .mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .mb-10 {
    margin-bottom: 2.5rem;
  }
  .mb-16 {
    margin-bottom: 4rem;
  }
  .mb-2 {
    margin-bottom: 0.5rem;
  }
  .mb-4 {
    margin-bottom: 1rem;
  }
  .mb-6 {
    margin-bottom: 1.5rem;
  }
  .mb-8 {
    margin-bottom: 2rem;
  }
  .inline-block {
    display: inline-block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .aspect-video {
    aspect-ratio: 16 / 9;
  }
  .h-12 {
    height: 3rem;
  }
  .h-6 {
    height: 1.5rem;
  }
  .w-12 {
    width: 3rem;
  }
  .w-6 {
    width: 1.5rem;
  }
  .w-full {
    width: 100%;
  }
  .max-w-4xl {
    max-width: 56rem;
  }
  .max-w-5xl {
    max-width: 64rem;
  }
  .max-w-6xl {
    max-width: 72rem;
  }
  .max-w-7xl {
    max-width: 80rem;
  }
  .flex-col {
    flex-direction: column;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .gap-12 {
    gap: 3rem;
  }
  .gap-2 {
    gap: 0.5rem;
  }
  .gap-4 {
    gap: 1rem;
  }
  .gap-6 {
    gap: 1.5rem;
  }
  .gap-8 {
    gap: 2rem;
  }
  .space-y-32 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(8rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(8rem * var(--tw-space-y-reverse));
  }
  .space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .rounded {
    border-radius: 0.25rem;
  }
  .rounded-2xl {
    border-radius: 1rem;
  }
  .rounded-full {
    border-radius: 9999px;
  }
  .rounded-lg {
    border-radius: 0.5rem;
  }
  .rounded-xl {
    border-radius: 0.75rem;
  }
  .border {
    border-width: 1px;
  }
  .border-b {
    border-bottom-width: 1px;
  }
  .border-t {
    border-top-width: 1px;
  }
  .border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
  }
  .border-gray-800 {
    --tw-border-opacity: 1;
    border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
  }
  .bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
  }
  .bg-footer {
    --tw-bg-opacity: 1;
    background-color: rgb(112 146 190 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-100 {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-200\/50 {
    background-color: rgb(229 231 235 / 0.5);
  }
  .bg-gray-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
  }
  .bg-gray-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
  }
  .bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  }
  .to-black {
    --tw-gradient-to: #000 var(--tw-gradient-to-position);
  }
  .p-1 {
    padding: 0.5rem !important;
  }
  .p-4 {
    padding: 1rem;
  }
  .p-6 {
    padding: 1.5rem;
  }
  .p-8 {
    padding: 2rem;
  }
  .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
  .py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
  .py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .pb-2 {
    padding-bottom: 0.5rem;
  }
  .pb-20 {
    padding-bottom: 5rem;
  }
  .pt-32 {
    padding-top: 8rem;
  }
  .pt-4 {
    padding-top: 1rem;
  }
  .text-left {
    text-align: left;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
  .text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .font-black {
    font-weight: 900;
  }
  .font-bold {
    font-weight: 700;
  }
  .font-light {
    font-weight: 300;
  }
  .font-medium {
    font-weight: 500;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .leading-relaxed {
    line-height: 1.625;
  }
  .leading-tight {
    line-height: 1.25;
  }
  .tracking-tighter {
    letter-spacing: -0.05em;
  }
  .tracking-widest {
    letter-spacing: 0.1em;
  }
  .text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }
  .text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
  }
  .text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
  }
  .text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  }
  .text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
  }
  .text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .shadow-2xl {
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
      var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(4px);
    -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
      var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
      var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
      var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
      var(--tw-backdrop-sepia);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
      var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
      var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
      var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
      var(--tw-backdrop-sepia);
  }
  .transition {
    transition-property: color, background-color, border-color, fill, stroke,
      opacity, box-shadow, transform, filter, -webkit-text-decoration-color,
      -webkit-backdrop-filter;
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
      backdrop-filter;
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
      backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .duration-300 {
    transition-duration: 300ms;
  }
  .hover\:-translate-y-2:hover {
    --tw-translate-y: -0.5rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y))
      rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y))
      scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .hover\:bg-black\/10:hover {
    background-color: rgb(0 0 0 / 0.1);
  }
  .hover\:text-black:hover {
    --tw-text-opacity: 1;
    color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  }
  .hover\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
  .hover\:opacity-90:hover {
    opacity: 0.9;
  }
  @media (min-width: 768px) {
    .md\:mb-0 {
      margin-bottom: 0px;
    }
    .md\:flex {
      display: flex;
    }
    .md\:w-1\/2 {
      width: 50%;
    }
    .md\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\:flex-row {
      flex-direction: row;
    }
    .md\:flex-row-reverse {
      flex-direction: row-reverse;
    }
    .md\:text-2xl {
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .md\:text-4xl {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    .md\:text-5xl {
      font-size: 3rem;
      line-height: 1;
    }
    .md\:text-6xl {
      font-size: 3.75rem;
      line-height: 1;
    }
  }
  @media (min-width: 1024px) {
    .lg\:pb-32 {
      padding-bottom: 8rem;
    }
    .lg\:pt-48 {
      padding-top: 12rem;
    }
    .lg\:text-7xl {
      font-size: 4.5rem;
      line-height: 1;
    }
  }

  .bubble {
    position: relative;
    background: #28c76f;
    border-radius: 1em;
    color: #fff;
    width: 40px;
    height: 28px;
    text-align: center;
  }

  /* 말풍선 꼬리 만들기 */
  .bubble::after {
    content: '';
    position: absolute;
    top: 9px;
    right: -6px;
    width: 0;
    height: 0;
    border-top-color: #28c76f;
    border-width: 5px 0 5px 6px;
    border-color: transparent #28c76f;
  }

  .bubble_t {
    position: relative;
    background: #28c76f;
    border-radius: 1em;
    color: #fff;
    width: 40px;
    height: 20px;
    text-align: center;
    padding-top: 3px !important;
  }

  /* 말풍선 꼬리 만들기 */
  .bubble_t::after {
    content: '';
    position: absolute;
    top: 6px;
    left: -5px;
    width: 0;
    height: 0;
    border-top-color: #28c76f;
    border-width: 4px 6px 4px 0;
    border-color: transparent #28c76f;
  }

  /* 무료체험 팝업 */
  .trial-modal-dialog {
    max-width: 640px;
  }
  .modal .modal-content.trial-modal {
    border: 0;
    border-radius: 1rem;
    overflow: hidden;
    position: relative;
    box-shadow:
      0 30px 60px -10px rgba(0, 0, 0, 0.5),
      0 0 40px rgba(59, 124, 240, 0.45) !important;   /* 블루 글로우 */
  }

  .modal-backdrop.show {
    opacity: 0.15 !important;
    backdrop-filter: blur(2px) !important;   /* 약하게. 없애려면 none */
  }
  .modal.show {
    backdrop-filter: blur(2px) !important;
  }
  .trial-modal-img {
    background: linear-gradient(180deg, #2a4fc9 0%, #3b7cf0 100%);
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
  .trial-modal-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  /* 모바일: 이미지 높이를 줄여 작은 화면에서도 신청 버튼까지 한 화면에 보이게 */
  @media (max-width: 767px) {
    .trial-modal-img { height: 190px; }
    .trial-modal-img img { object-position: center 35%; }
  }
  .trial-modal-close {
    position: absolute;
    top: 10px;
    right: 12px;
    z-index: 10;
    font-size: 18px;
    line-height: 1;
    color: #9ca3af;
  }
  .trial-modal-close:hover { color: #000; }
  .trial-modal-btn {
    display: block;
    text-align: center;
    padding: 0.75rem 1rem;
    font-size: 1rem;
  }
  .space-y-2 > :not([hidden]) ~ :not([hidden]) { margin-top: 0.5rem; }

  .trial-modal-input {
    width: 100%;
    padding: 0.65rem 0.85rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 0.9rem;
    color: #111827;
    outline: none;
  }
  .trial-modal-input:focus { border-color: #1951DC; }
  .trial-modal-input.is-invalid { border-color: #ea5455; }
  .trial-modal-error {
    margin-top: 0.3rem !important;
    font-size: 0.75rem;
    color: #ea5455;
  }
  .trial-modal-agree {
    display: flex;
    align-items: center;
    gap: 6px;
    margin: 0.75rem 0;
    font-size: 0.75rem;
    color: #6b7280;
    cursor: pointer;
  }
  .trial-modal-agree a { text-decoration: underline; }
  .trial-modal-btn { width: 100%; }
  .trial-modal-btn:disabled {
    background-color: #c7cdd8 !important;
    cursor: not-allowed;
  }
  /* 팝업 문구 영역 여백 (테마의 mb-* 값이 커서 직접 지정) */
  .trial-modal-eyebrow { margin-bottom: 10px !important; }
  .trial-modal-title { margin-bottom: 18px !important; }
  .trial-modal-features { margin-bottom: 14px !important; }
  .trial-modal-notice {
    margin-bottom: 18px !important;
    padding: 0.4rem 0.7rem;
    background-color: #eef3ff;
    border-radius: 0.375rem;
    font-size: 0.75rem;
    line-height: 1.5;
    color: #374151;
    word-break: keep-all;
  }
  .trial-modal-notice strong { color: #1951DC; }
  .trial-modal-done-icon {
    font-size: 2.5rem;
    margin-bottom: 0.75rem;
  }

  /* 푸터 */
  .biz-info {
    padding-bottom: 0.75rem;
    margin-bottom: 0.75rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  }
  .biz-info-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 0.8rem;
    line-height: 1.8;
    color: #eef2f8;
  }
  .biz-info-row li {
    display: flex;
    gap: 6px;
  }
  .biz-info-row strong { color: #fff; }
  /* 항목 사이 구분선 */
  .biz-info-row li + li::before {
    content: "|";
    margin: 0 10px;
    color: rgba(255, 255, 255, 0.45);
  }
  .footer-bottom {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
  }

  /* 모바일: 한 줄에 한 항목씩, 구분선 제거 */
  @media (max-width: 767px) {
    .biz-info-row { flex-direction: column; align-items: flex-start; }
    .biz-info-row li + li::before { content: none; }
  }

</style>
